import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import ClipLoader from "react-spinners/ClipLoader";
import storage from "../../utils/storage";
import { ORDER_COMPLETE, CART } from "../../route/routeURL";
import WithContext from "../../Layouts/MainMessage/WithContext";
const ImepayCallBackUrl = (props) => {
  let history = useHistory();
  const [isLoading] = useState(true);

  useEffect(() => {
    if (!storage.isLoggedIn()) {
      history.replace("/");
    }
    let order = "";
    if (new URLSearchParams(props.location.search).get("order")) {
      var orderData = new URLSearchParams(props.location.search).get("order");
      order = orderData;
    }
    if (order == "completed") {
      setTimeout(
        () => (
          history.replace(ORDER_COMPLETE + "?order=completed"),
          props.value.setMessage("Your order is completed successfully!")
        ),
        2000
      );
    } else if (order == "cancelled") {
      setTimeout(
        () => (
          history.replace(CART),
          props.value.setErrorMessage(
            "Your order has been cancelled or failed!"
          )
        ),
        2000
      );
    } else {
      setTimeout(() => history.replace(CART), 2000);
    }
  }, []);
  return (
    <React.Fragment>
      <div className="container" style={{ height: "400px" }}>
        <div
          className="container"
          style={{ textAlign: "center", padding: "100px 0px" }}
        >
          <ClipLoader
            css={{ margin: "0 auto" }}
            size={150}
            color={"#123abc"}
            loading={isLoading}
          />
          <br />
          <br />
          <b>Will redirect you in a sec</b>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WithContext(ImepayCallBackUrl);
